import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../services/contexts/AuthContext';
import TenantTechnicianSidebar from './components/TenantTechnicianSidebar';
import TenantTechnicianDashboard from './pages/TenantTechnicianDashboard';
import PatientOnboarding from './pages/PatientOnboarding';
import { LogOut } from 'lucide-react';

const TenantTechnicianApp = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState('dashboard');

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex h-screen bg-va-neutral-50">
      {/* Tenant Technician Sidebar */}
      <TenantTechnicianSidebar activeView={activeView} setActiveView={setActiveView} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <header className="bg-white shadow-sm border-b border-va-neutral-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <h1 className="text-2xl font-bold text-va-neutral-900">Technical Operations Portal</h1>
              <p className="text-sm text-va-neutral-600">Equipment management and patient onboarding</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-va-neutral-900">{user?.name}</p>
                <p className="text-xs text-va-neutral-500">Technician</p>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-va-neutral-700 hover:text-va-neutral-900 hover:bg-va-neutral-100 rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-y-auto p-6">
          <Routes>
            <Route path="/" element={<Navigate to="/tenant-technician/dashboard" replace />} />
            <Route path="/dashboard" element={<TenantTechnicianDashboard />} />
            <Route path="/onboarding" element={<PatientOnboarding />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default TenantTechnicianApp;